import { brand } from '../../app/brand';
import './BrandLogo.css';

interface BrandLogoProps {
  variant?: 'wordmark' | 'signature' | 'symbol';
  decorative?: boolean;
}

/** The accepted outlined artwork, including its original letterforms. */
export function BrandLogo({ variant = 'signature', decorative = false }: BrandLogoProps) {
  const square = variant === 'symbol';
  return (
    <span className="slad-brand-logo" aria-hidden={decorative || undefined}>
      <img
        className="slad-brand-logo__light"
        src={`/brand/slad-${variant}.svg`}
        alt={decorative ? '' : `${brand.fullName} (SLAD)`}
        width={square ? 171 : 421}
        height={square ? 171 : variant === 'signature' ? 142 : 171}
      />
      <img
        className="slad-brand-logo__dark"
        src={`/brand/slad-${variant}-dark.svg`}
        alt={decorative ? '' : `${brand.fullName} (SLAD)`}
        width={square ? 171 : 421}
        height={square ? 171 : variant === 'signature' ? 142 : 171}
      />
    </span>
  );
}
